var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"map-page"}},[_vm._m(0),(_vm.selectedEntity)?_c('EntityView',{attrs:{"entity":_vm.selectedEntity},on:{"closed":function($event){_vm.selectedEntity = null}}}):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"map-container"}},[_c('div',{attrs:{"id":"map"}})])
}]

export { render, staticRenderFns }